import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'
import {IconItemSchema} from '../components/iconItem'
import {ImageLinkItemSchema} from '../components/imageLinkItem'
import {LinkSchema} from '../components/link'
import {MediaSchema} from '../components/media'
import {SubnavSchema} from '../components/subnav'
import {TextItemSchema} from '../components/textItem'

export const CategoryHeroVariantEnum = z.enum(['Default', '50/50', 'Image Cards', 'Icon Cards'])

export type CategoryHeroVariant = z.infer<typeof CategoryHeroVariantEnum>

export const TemplateFlexSuiteCategorySchema = buildEntrySchemaFor('templateFlexSuiteCategory', {
  fields: z.lazy(() =>
    z.object({
      title: z.string().optional(),
      subNav: safeOptional(SubnavSchema),
      introLogos: safeOptional(z.array(z.string())),
      introLogoLink: safeOptional(LinkSchema),
      introStats: safeOptional(z.array(TextItemSchema)),
      heroHeading: RichTextSchema,
      heroLabel: z.string().optional(),
      heroDescription: safeOptional(RichTextSchema),
      heroVariant: safeOptional(CategoryHeroVariantEnum),
      heroAsset: safeOptional(MediaSchema),
      heroCtaOne: LinkSchema,
      heroCtaTwo: safeOptional(LinkSchema),
      heroImageCards: safeOptional(z.array(ImageLinkItemSchema)),
      heroIconCards: safeOptional(z.array(IconItemSchema)),
    }),
  ),
})

export type TemplateFlexSuiteCategory = z.infer<typeof TemplateFlexSuiteCategorySchema>
